import { type TranslationTree } from '@/i18n/types';

export const messages = {
  events: {
    title: 'Eventos por perto',
    description: 'O evento aparece para atletas da região, e o portal mostra quantos pretendem ir.',
  },
  offers: {
    title: 'Produtos e serviços',
    description:
      'Ofertas aparecem no app para o público combinado com a Bodyprint. Cliques e contatos ficam no portal.',
  },
  media: {
    title: 'Fotografia esportiva',
    description:
      'Quando a plataforma encontra fotos do atleta, o app avisa e leva até o site dela para a compra.',
  },
  approved: {
    title: 'Aprovado pela Bodyprint',
    description: 'A conta e cada evento ou oferta passam por uma análise antes de entrar no app.',
  },
} satisfies TranslationTree;
